<script>
export default {
  name: "payment",
  data() {
    return {
      locations: [],
      form: {
        card_name: null,
        card_number: null,
        card_cvv: null,
        card_expiration_date: null
      }
    };
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  }
};
</script>

<template>
  <div>
    <div
      v-if="locations.length === 0"
      class="alert alert-custom alert-light-danger fade show mb-5"
      role="alert"
    >
      <div class="alert-icon"><i class="flaticon-warning"></i></div>
      <div class="alert-text">Please setup locations in Step 1</div>
      <div class="alert-close">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="ki ki-close"></i></span>
        </button>
      </div>
    </div>
    <div v-if="locations.length > 0">
      <p>
        Enter your credit card information. We'll bill you automatically at the
        end of every month for any active campaigns.
      </p>

      <b-row>
        <b-col>
          <b-form-input
            id="cardholder_name"
            v-model="form.card_name"
            placeholder="Cardholder Name"
          ></b-form-input>
        </b-col>
        <b-col>
          <b-form-input
            id="card_number"
            v-model="form.card_number"
            placeholder="Card Number"
          ></b-form-input>
        </b-col>
        <b-col>
          <b-form-input
            id="card_cvv"
            v-model="form.card_cvv"
            placeholder="CVV"
          ></b-form-input>
        </b-col>
        <b-col>
          <b-form-input
            id="card_expiration_date"
            v-model="form.card_expiration_date"
            placeholder="Expiration Date"
          ></b-form-input>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
